import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ConsumerLoanTargetPath } from '../../domain/types';
import { getPath } from '../../helpers/url';
import { useAppDispatch } from '../../hooks';
import useArnFromPath from '../../hooks/useArnFromPath';
import useSettings from '../../hooks/useSettings';
import { invalidateStore } from '../../store/store';
import { setCurrentPage } from '../../store/wizard/wizard';

const InitDraftPage = () => {
    const dispatch = useAppDispatch();
    const settings = useSettings();
    const navigate = useNavigate();

    const applicationReferenceNumber = useArnFromPath();

    useEffect(() => {
        invalidateStore(dispatch);
        dispatch(setCurrentPage(0));

        navigate(
            getPath(
                ConsumerLoanTargetPath.draft,
                settings.languageCode,
                settings.countryCode,
                applicationReferenceNumber,
            ),
        );
    }, [dispatch]);

    return (
        <Box display="flex" justifyContent="center" marginBottom={2} marginTop={2}>
            <CircularProgress />
        </Box>
    );
};

export default InitDraftPage;
